import React, { useState } from 'react';


import SaveCancelButton from '../shared/buttons/SaveCancelButton';
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import postData from '../../utilities/postData';

const PrintConfirmModal = ({
    items,
    commitUrl,
    resetParent,
    show,
    setShow
}) => {
    const [printed, setPrinted] = useState(false);

    const printEnvelopes = () => { 
        var customerIds = items.filter((item) => {
            if (item.sendDay7FollowUp || item.sendDay30FollowUp
                || item.sendThankYou || item.sendSatisfaction) {
                return true;
            }
        }).map(item => item.customerId);
        postData('/followups/getEnvelopes', customerIds, () => setPrinted(true));
    }

    const commit = () => {
        postData(commitUrl, items, () => {
            resetParent();
            setShow(false);
            setPrinted(false);
        });
    }

    const cancel = () => {
        setShow(false);
        setPrinted(false);
    }

    return (
        <Modal dialogClassName="print-confirm-modal"
            size="sm"
            show={show}
            onHide={() => setShow(false)}
            backdrop="static"
            centered>
            <Modal.Body>
                <Row className="justify-content-center">
                    <Col xs="auto" className="dashboard-follow-ups-title">
                        {printed ? 'Did Everything Print OK?' : 'Print Envelopes?'}
                    </Col>
                </Row>
                {printed ? (
                    <Row className="justify-content-center p-2">
                        <Col xs="auto">
                            <SaveCancelButton
                                saveText="Yes"
                                saveItem={commit}
                                cancelText="No"
                                cancelEdit={cancel}
                            />
                        </Col>
                    </Row>
                ) : (
                    <Row className="justify-content-center p-2">
                        <Col xs="auto">
                            <SaveCancelButton
                                saveText="Yes"
                                saveItem={printEnvelopes}
                                cancelText="No"
                                cancelEdit={() => setPrinted(true)}
                            />
                        </Col>
                    </Row>
                )}
            </Modal.Body>
        </Modal>
    );
}

export default PrintConfirmModal;
